/* Bezelle theme scripts. No dependencies. */
(() => {
  const routes = (window.Bezelle && window.Bezelle.routes) || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const parser = new DOMParser();

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const panel = $('.drawer__panel', drawer);
    panel && panel.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  function renderDrawer(sectionsHtml) {
    if (!drawer || !sectionsHtml || !sectionsHtml['cart-drawer']) return;
    const doc = parser.parseFromString(sectionsHtml['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer-content]', doc);
    const current = $('[data-cart-drawer-content]', drawer);
    if (fresh && current) {
      current.replaceWith(fresh);
      setCount(fresh.dataset.itemCount);
    }
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; });
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    const change = e.target.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      changeLine(Number(change.dataset.lineChange), Number(change.dataset.qty));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  async function changeLine(line, quantity) {
    drawer && drawer.classList.add('is-busy');
    try {
      const res = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, quantity), sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message);
      renderDrawer(data.sections);
    } catch (err) {
      window.location.href = routes.cart_url;
    } finally {
      drawer && drawer.classList.remove('is-busy');
    }
  }

  /* ---------- Shared add to bag ---------- */
  async function addToBag(form, buttons, errorEl) {
    buttons.forEach((b) => b.classList.add('is-loading'));
    if (errorEl) errorEl.hidden = true;
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
      renderDrawer(data.sections);
      openDrawer();
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      else window.alert(err.message);
    } finally {
      buttons.forEach((b) => b.classList.remove('is-loading'));
    }
  }

  // Quick add forms (home page colourway selector)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-quick-add]');
    if (!form || !drawer) return;
    e.preventDefault();
    addToBag(form, $$('[type="submit"]', form), null);
  });

  /* ---------- Colourway selector tabs ---------- */
  $$('[data-selector]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      const list = tab.parentElement;
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - list.clientWidth / 2 + tab.clientWidth / 2, behavior: 'smooth' });
      }
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  });

  /* ---------- Product page ---------- */
  function initProduct(root = document) {
    const section = $('[data-product-section]', root);
    if (!section) return;

    // Gallery counter for the mobile swipe track
    const track = $('[data-gallery-track]', section);
    const indexEl = $('[data-gallery-index]', section);
    if (track && indexEl) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth) + 1;
        indexEl.textContent = i;
      }, { passive: true });
    }

    // Keep the selected bezel in view when the swatch row scrolls (mobile)
    const current = $('.colourways__swatch[aria-current="true"]', section);
    if (current) {
      const list = current.closest('.colourways__list');
      if (list.scrollWidth > list.clientWidth) {
        list.scrollLeft = current.parentElement.offsetLeft - list.clientWidth / 2 + current.clientWidth / 2;
      }
    }

    // Quantity stepper
    $$('[data-qty]', section).forEach((wrap) => {
      const input = $('input', wrap);
      $$('[data-qty-step]', wrap).forEach((btn) => {
        btn.addEventListener('click', () => {
          const next = Math.min(Number(input.max) || 99, Math.max(1, (Number(input.value) || 1) + Number(btn.dataset.qtyStep)));
          input.value = next;
        });
      });
    });

    // Variant picker (for products with real options, such as the gift set)
    const picker = $('[data-variant-picker]', section);
    if (picker) {
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      picker.addEventListener('change', () => {
        const selected = $$('input:checked', picker).map((i) => i.value);
        const variant = variants.find((v) => v.options.every((o, idx) => o === selected[idx]));
        updateVariant(section, variant);
      });
    }

    // Add to bag
    const form = $('[data-product-form]', section);
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!drawer) return; // fall back to normal form post
        e.preventDefault();
        const buttons = $$(`[form="${form.id}"][type="submit"], [data-add-button]`);
        addToBag(form, buttons, $('[data-form-error]', form));
      });
    }

    // Sticky bar appears once the main button has scrolled above the viewport
    const sticky = $('[data-sticky-buy]', root) || $('[data-sticky-buy]');
    const addBtn = $('[data-add-button]', section);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        $$('button', sticky).forEach((b) => { b.tabIndex = passed ? 0 : -1; });
      });
      io.observe(addBtn);
    }
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
    }).format(cents / 100);
  }

  function updateVariant(section, variant) {
    const idInput = $('[data-variant-id]', section);
    const buttons = $$('[data-add-button], .sticky-buy__btn');
    if (!variant) {
      buttons.forEach((b) => { b.disabled = true; });
      const label = $('[data-add-label]', section);
      if (label) label.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    $$('[data-price] .price__current').forEach((el) => { el.textContent = formatMoney(variant.price); });
    buttons.forEach((b) => { b.disabled = !variant.available; });
    const label = $('[data-add-label]', section);
    if (label) label.textContent = variant.available ? 'Add to bag' : 'Sold out';

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(history.state, '', url);

    if (variant.featured_media) {
      const media = $(`[data-media-id="${variant.featured_media.id}"]`, section);
      const track = $('[data-gallery-track]', section);
      if (media && track && track.scrollWidth > track.clientWidth) {
        track.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  /* ---------- Colourway swap without a full reload ---------- */
  const pageCache = new Map();
  function fetchPage(url) {
    if (!pageCache.has(url)) {
      pageCache.set(url, fetch(url, { credentials: 'same-origin' }).then((r) => {
        if (!r.ok) throw new Error('Page failed to load');
        return r.text();
      }));
    }
    return pageCache.get(url);
  }

  async function swapTo(url, push = true) {
    const main = $('#MainContent');
    document.body.classList.add('is-swapping');
    try {
      const html = await fetchPage(url);
      const doc = parser.parseFromString(html, 'text/html');
      const freshMain = $('#MainContent', doc);
      if (!freshMain || !$('[data-product-section]', freshMain)) throw new Error('Not a product page');
      main.innerHTML = freshMain.innerHTML;
      document.title = doc.title;
      if (push) history.pushState({ bezelle: true }, '', url);
      // Re-run inline JSON-LD and app scripts is unnecessary for the swap; init our own behaviour
      initProduct(main);
      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
    } catch (err) {
      window.location.href = url;
    } finally {
      document.body.classList.remove('is-swapping');
    }
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-colourway-link]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (link.getAttribute('aria-current') === 'true') { e.preventDefault(); return; }
    e.preventDefault();
    link.classList.add('is-loading');
    swapTo(link.href);
  });
  document.addEventListener('pointerenter', (e) => {
    const link = e.target.closest && e.target.closest('[data-colourway-link]');
    if (link) fetchPage(link.href).catch(() => {});
  }, true);
  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.bezelle) swapTo(window.location.href, false);
  });
  if ($('[data-product-section]')) history.replaceState({ bezelle: true }, '', window.location.href);

  initProduct();
})();


/* Swipe between colourways on the home page selector */
(() => {
  document.querySelectorAll('[data-selector]').forEach((root) => {
    const stage = root.querySelector('.selector__stage');
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (!stage || tabs.length < 2) return;
    let startX = 0;
    let startY = 0;
    stage.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
      const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      const next = dx < 0 ? (current + 1) % tabs.length : (current - 1 + tabs.length) % tabs.length;
      tabs[next].click();
    }, { passive: true });
  });
})();

/* Make it a pair: add a second colourway from inside the bag */
(() => {
  const parser = new DOMParser();
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pair-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${window.Bezelle.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.pairAdd), quantity: 1 }],
          sections: ['cart-drawer'],
          sections_url: window.location.pathname
        })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add');
      const doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-content]');
      const current = document.querySelector('[data-cart-drawer-content]');
      if (fresh && current) {
        current.replaceWith(fresh);
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = fresh.dataset.itemCount; });
      }
    } catch (err) {
      btn.classList.remove('is-loading');
      window.location.href = window.Bezelle.routes.cart_url;
    }
  });
})();